import { t } from 'i18next';
import { joinCampaign } from 'src/shared';

type LpHeroProps = {
  heroUrl: string;
  gimmickUrl: string;
  eventName: string;
  programId: string | undefined;
  isPublished: boolean | undefined;
};

export default function LpHero({ heroUrl, gimmickUrl, eventName, programId, isPublished }: LpHeroProps) {
  function handleJoin() {
    if (isPublished && programId) {
      joinCampaign(programId);
    }
  }

  return (
    <section className="hero" aria-label="Hero">
      <div className="hero__media">
        <img src={heroUrl} alt="" />
      </div>
      <div className="hero__scrim" />

      <div className="wrap hero__inner">
        {gimmickUrl && (
          <img src={gimmickUrl} alt={eventName} className="hero__logo" />
        )}
        <span className="eyebrow">
          <span className="dot" />
          {t('landingPage.v2.hero.eyebrow')}
        </span>
        <h1 className="display">
          {t('landingPage.v2.hero.headlinePre')}{' '}
          <span className="mark">{t('landingPage.v2.hero.headlineMark')}</span>
          {t('landingPage.v2.hero.headlinePost')}
        </h1>
        <p className="lead">{t('landingPage.v2.hero.subhead')}</p>
        <div className="hero__cta">
          <button
            className="btn btn--primary"
            onClick={handleJoin}
            disabled={!isPublished}
          >
            {isPublished
              ? t('landingPage.v2.hero.cta')
              : t('landingPage.header.comingSoon')}
            {isPublished && <span className="arr">→</span>}
          </button>
          <span className="hint">{t('landingPage.v2.hero.hint')}</span>
        </div>
      </div>
    </section>
  );
}
